import { ErcProfile } from '@pmp/api';
import { CrudMode, FormItem, transformUppercaseNoSpaces } from '@ohpen/enso-ui';
import type { RenderFormItem } from '@ohpen/enso-ui';

export const getFormSchema = (
  renderErcBands: RenderFormItem<ErcProfile>,
  renderAlert: RenderFormItem<ErcProfile>,
  mode?: CrudMode | null,
  isUsed?: boolean | null,
): FormItem[] => {
  const disabled = mode === CrudMode.VIEW || isUsed;

  return [
    {
      renderFormItem: renderAlert,
    },
    {
      title: 'pmp.erc.labels.ercProfileId',
      dataIndex: 'ercProfileId',
      fieldProps: {
        disabled: mode !== CrudMode.CREATE,
      },
      formItemProps: {
        required: true,
        getValueFromEvent: transformUppercaseNoSpaces,
      },
    },
    {
      title: 'pmp.erc.labels.ercProfileName',
      dataIndex: 'name',
      formItemProps: {
        required: true,
      },
      fieldProps: {
        disabled: mode === CrudMode.VIEW,
      },
    },
    {
      title: 'pmp.erc.labels.rollingOrFixed',
      dataIndex: 'rollingOrFixed',
      valueType: 'select',
      formItemProps: {
        required: true,
      },
      fieldProps: {
        disabled,
        options: [
          { label: 'Rolling', value: false },
          { label: 'Fixed', value: true },
        ],
        defaultValue: false,
        allowClear: false,
      },
    },
    {
      title: 'pmp.erc.labels.ercBands',
      dataIndex: 'penaltyTiers',
      renderFormItem: renderErcBands,
      formItemProps: {
        required: true,
      },
      fieldProps: {
        disabled,
      },
    },
  ];
};
